import { GoogleGenAI } from "@google/genai";

export const getCareerAdvice = async (
  currentSkills: string,
  targetTrack: string,
  targetLevel: string,
  struggles: string
) => {
  const ai = new GoogleGenAI({ apiKey: process.env.API_KEY });
  
  const response = await ai.models.generateContent({
    model: 'gemini-3-flash-preview',
    contents: `
      Act as an AWS Senior Staff Engineer and Solutions Architect. 
      I want "Not HR Fluff" advice for an engineer's career progression.
      
      The user's current skills: ${currentSkills}. 
      Target Track: ${targetTrack}.
      Target Level: ${targetLevel}. 
      Current struggle: ${struggles}.

      Provide a 3-step technical roadmap to reach that level. 
      Focus on specific AWS services (e.g., EKS, Transit Gateway, EventBridge), 
      architectural patterns (e.g., CQRS, Strangler Fig, Multi-region active-active), 
      and the "Mental Shift" required (e.g., moving from ticket-taker to system-owner).
      
      If the user is moving from an Engineering role to an Architecture role, 
      emphasize trade-off analysis and the Well-Architected pillars.
      Be direct, technical, and blunt.
    `,
    config: {
      temperature: 0.7
    }
  });

  return response.text;
};